import React, {Component} from 'react';
import {connect} from 'react-redux';
import {chain, filter} from 'lodash';
import {Card, Loader, Checkbox, Tab, Icon} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {formsSections} from '../../../common/constants/ftr';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import './list.scss';

class FormsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'formTypeSelected': 'FTR',
      'panes': [],
      'activeTabIndex': 0,
      'categorySelected': '',
    };
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.changeTabIndex = this.changeTabIndex.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.FormsManage,
        scopes.Create
      )
    ) {
      this.props.push(paths.AccessDenied);
    }
    this.props.clearForms();
    this.fetchFormsTemplates();
    this.getCategories();
  }

  getCategories() {
    const {forms} = this.props;
    const categories = chain(forms)
      .groupBy('section')
      .map((values, i) => {
        return {
          'name': i,
        };
      })
      .value();

    const panes = [];
    categories.forEach((category) => {
      const categoryName = category.name;
      const categoryData = formsSections[categoryName];
      panes.push({
        'menuItem': {
          'key': categoryName,
          'icon': categoryData.icon,
          'content': categoryData.name,
        },
      });
    });

    const newState = {
      panes,
    };

    if (panes[0]) {
      const categorySelected =
        panes[0].menuItem && panes[0].menuItem.key ? panes[0].menuItem.key : '';
      newState.categorySelected = categorySelected;
      newState.activeTabIndex = 0;
    }

    this.setState(newState);
  }

  componentDidUpdate(prevProps) {
    const {forms} = this.props;
    if (prevProps.forms !== forms) {
      this.getCategories();
    }
  }

  fetchFormsTemplates() {
    const {formTypeSelected} = this.state;
    this.props.fetchFormsList(formTypeSelected);
  }

  goFormTemplate(formId) {
    const {formTypeSelected} = this.state;
    this.props.push(`/formulario/${formTypeSelected}/${formId.$oid}/nuevo`);
  }

  getItemsByCategory() {
    const {forms} = this.props;
    const {categorySelected} = this.state;
    const formsFiltered = filter(forms, {'section': categorySelected});

    return formsFiltered.map((form) => {
      return (
        <div
          className='card__ftr'
          key={form._id.$oid}
          onClick={() => this.goFormTemplate(form._id)}
        >
          {form.name}
        </div>
      );
    });
  }

  getFormsByCategory() {
    const {categorySelected} = this.state;
    if (!categorySelected) {
      return <div>Seleccione una categoría</div>;
    }

    return this.getItemsByCategory();
  }

  getCategoryIcon() {
    const {categorySelected} = this.state;
    if (!categorySelected) {
      return null;
    }
    return (
      <div className='icon-container'>
        <Icon className={formsSections[categorySelected].icon} size='massive' />
      </div>
    );
  }

  changeTabIndex(event, data) {
    const tabSelected = data.activeIndex;
    const itemSelected = data.panes[tabSelected];

    this.setState({
      'activeTabIndex': tabSelected,
      'categorySelected': itemSelected.menuItem.key,
    });
  }

  onCheckboxChange(event, {value}) {
    this.setState({'formTypeSelected': value, 'categorySelected': ''}, () =>
      this.fetchFormsTemplates()
    );
  }

  renderLoaderOrForms() {
    const {loading} = this.props;
    if (loading) {
      return <Loader active inline='centered' />;
    }
    return (
      <div className='container__wrapper'>{this.getFormsByCategory()}</div>
    );
  }

  render() {
    const {formTypeSelected, panes, activeTabIndex} = this.state;
    return (
      <div className='forms-template-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Crear Formularios</h2>
              <div className='title-bar-actions'>
                <h4>Tipo:</h4>
                <Checkbox
                  value='FTR'
                  label='FTR'
                  checked={formTypeSelected === 'FTR'}
                  onChange={this.onCheckboxChange}
                  radio
                />
                <Checkbox
                  value='RSR'
                  label='RSR'
                  checked={formTypeSelected === 'RSR'}
                  onChange={this.onCheckboxChange}
                  radio
                />
              </div>
            </div>
          </div>

          <Tab
            menu={{'secondary': true, 'pointing': true, 'color': 'red'}}
            panes={panes}
            activeIndex={activeTabIndex}
            onTabChange={this.changeTabIndex}
          />
        </Card>
        <Card fluid raised className='menu-container'>
          {this.renderLoaderOrForms()}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {category} = ownProps.params;
  return {
    category,
    'loading': state.listFTR.loading,
    'forms': state.listFTR.list,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    'goBack': ownProps.history.goBack,
  };
};

const {
  withRouter,
  clearForms,
  fetchFormsList,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  clearForms,
  fetchFormsList,
})(FormsList));
